import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getExpedientesTipo,
  getTiposExpedientesCampos,
  setTipoExpediente,
} from '../../actions/expedientes'

const ExpedientesMenu = () => {
  const dispatch = useDispatch()

  const tipos_expedientes = useSelector(state => state.expedientes.tipos_expedientes)
  const tipo_expediente_seleccionado = useSelector(
    state => state.expedientes.tipo_expediente_seleccionado,
  )
  const tipos_expedientes_comentarios = useSelector(
    state => state.expedientes.tipos_expedientes_comentarios,
  )
  const mostrar = useSelector(state => state.expedientes.mostrar)
  const orden = useSelector(state => state.expedientes.orden)
  const inicio = useSelector(state => state.expedientes.inicio)
  const fin = useSelector(state => state.expedientes.fin)

  useEffect(() => {
    return () => {
      dispatch(setTipoExpediente(''))
    }
  }, [])

  useEffect(() => {
    if (tipos_expedientes?.length > 0 && tipo_expediente_seleccionado === '') {
      dispatch(setTipoExpediente('0'))
      dispatch(getExpedientesTipo(tipos_expedientes['0'], mostrar, orden, inicio, fin))
    }
  }, [tipos_expedientes])

  const handleTipoExpediente = e => {
    e.preventDefault()
    if (typeof e.target.dataset.expediente !== 'undefined') {
      dispatch(setTipoExpediente(e.target.dataset.expediente))
      dispatch(getTiposExpedientesCampos(tipos_expedientes[e.target.dataset.expediente]))
      dispatch(
        getExpedientesTipo(
          tipos_expedientes[e.target.dataset.expediente],
          mostrar,
          orden,
          inicio,
          fin,
        ),
      )
    }
  }

  const getTooltipTitle = (index) => {
    const comentarios = tipos_expedientes_comentarios || []

    const comentario = comentarios.find(
      (com) => com.tipo_expediente === tipos_expedientes[index].tipo_expediente
    )

    return comentario?.descripcion_reducida || tipos_expedientes[index].nombre
  }

  return (
    <header className='menu-expedientes'>
      <div className='esquema-color'>
        <div className='container'>
          <nav>
            <ul className='listado_tipos_expedientes'>
              {tipos_expedientes?.length > 0
                ? tipos_expedientes.map((expediente, index) => {
                  return (
                    <li
                      key={index}
                      className={'item-' + index}>
                      <a
                        href='/#'
                        data-expediente={index}
                        onClick={handleTipoExpediente}
                        title={getTooltipTitle(index)}
                        style={
                          tipo_expediente_seleccionado === index.toString()
                            ? { fontWeight: 'bold' }
                            : null
                        }>
                        {expediente.nombre.toUpperCase()}
                      </a>
                    </li>
                  )
                })
                : ''}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default ExpedientesMenu
